"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomNavigationAction = void 0;
var BottomNavigationAction_1 = __importDefault(require("@mui/material/BottomNavigationAction"));
var patch_base_button_components_1 = __importDefault(require("./patch-base-button-components"));
exports.BottomNavigationAction = (0, patch_base_button_components_1.default)(BottomNavigationAction_1.default);
//# sourceMappingURL=bottom-navigation-action.js.map